import script from "./HeaderSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderSection.vue?vue&type=script&setup=true&lang=js"

import "./HeaderSection.vue?vue&type=style&index=0&id=6c5854fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c5854fe"]])

export default __exports__